"use strict";
/** Copied from agronomy-ui repo */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Translations = void 0;
const en_US_json_1 = __importDefault(require("../config/language/en-US.json"));
const en_CA_json_1 = __importDefault(require("../config/language/en-CA.json"));
const pt_BR_json_1 = __importDefault(require("../config/language/pt-BR.json"));
const fr_CA_json_1 = __importDefault(require("../config/language/fr-CA.json"));
exports.Translations = {
    "en-US": en_US_json_1.default,
    "en-CA": en_CA_json_1.default,
    "fr-CA": fr_CA_json_1.default,
    "pt-BR": pt_BR_json_1.default,
    /**
     * Need this since the User Service stores locales in lower case for
     * some strange, historical reason.
     */
    "en-us": en_US_json_1.default,
    "en-ca": en_CA_json_1.default,
    "fr-ca": fr_CA_json_1.default,
    "pt-br": pt_BR_json_1.default,
    /**
     * Fallbacks
     */
    en: en_US_json_1.default,
    fr: fr_CA_json_1.default,
    pt: pt_BR_json_1.default,
};
